import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Suppress WASM and BarcodeDetector errors
        const errorMessage = error?.toString() || error?.message || '';
        if (
            errorMessage.includes('wasm') ||
            errorMessage.includes('Aborted') ||
            errorMessage.includes('async and sync fetching') ||
            errorMessage.includes('BarcodeDetector') ||
            errorMessage.includes('Barcode detection service unavailable')
        ) {
            console.log('[ErrorBoundary] Scanner error suppressed:', errorMessage);
            // Reset the error state so component can continue
            this.setState({ hasError: false, error: null });
            return;
        }

        // Log other errors
        console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Render fallback UI for non-WASM errors
            return this.props.fallback || <div>Something went wrong.</div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
